module.exports = __webpack_public_path__ + "static/media/celu1_2x.af94bb35.png";